import { Component, OnInit, Injector, ViewChild } from '@angular/core';
import { MainComponent } from 'src/modules/base/components/main-component/main.component';
import { ActivatedRoute } from '@angular/router';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import accessionIdentifierDecorator from 'src/decorators/accessionIdentifierDecorator';


@Component({
    selector: 'app-payor-details',
    templateUrl: './payor-details.component.html',
    styleUrls: ['./payor-details.component.scss'],
    standalone: false
})
export class PayorDetailsComponent extends MainComponent implements OnInit {
  public _currentData: any = {};
 config_value : any;
  @ViewChild("formViewChild") someInput: any;
  constructor(
    public injector: Injector,
    public route: ActivatedRoute,
    public dialogConfig: DialogConfig
  ) {
    super(injector,route);
  }

  ngOnInit() {
    this._currentData.config = {
      "filterForm" : false,
      "clearOnSave": false,
      "delegateSave": true,
      "cancelRoute": ''
    }
     
        
    this._currentData.currentData = this.dialogConfig;
    this.baseService.getResourceDef('op_pharmacy_payer_details', (resourceDef) => {
      this._currentData.resource = resourceDef.resource;
      this.getData(resourceDef);
    });
  }

  getData(resourceDef) {
    if (resourceDef) {
      this.baseService.getReferredField(resourceDef.form, (response) => {
        this._currentData._currentFormFields = {};
        this._currentData._currentFormFields.blocks = [];
        this._currentData._currentFormFields.blocks = response;
        if(this._currentData.currentData.insurance_mandatory){
          for(let d of this._currentData._currentFormFields.blocks[0].fields){
              if(d.name == "sponser_id"){
                d.required = true;
                break;
              }
          }
        }

        if (this._currentData.currentData.refLetterMandatory) {
          let config_checker = this._currentData.currentData.refLetterMandatory.some(
            value => value.id === "all" || (value.id === 'op_pharmacy'));
          for (let d of this._currentData._currentFormFields.blocks[0].fields) {
            if (d.name == "ref_letter_number") {
              if (config_checker) {
                d.required = true;
                break;
              }
              else {
                d.required = false;
                break;
              }
 
            }
          }
        }
  
      //   setTimeout(() => {
      //   if (this.someInput && this.someInput.popupForm) {
      //     this.opAmount();
      //   }
      // });
      });
    } else {
      alert('ERROR occurred, please fix');
    }

  }

  sendToParent(event) {
    try {
      const sponsorId = event?.result?.sponser_id;
      let sponsorNameMissing = !event?.result?.sponsor_name;
      let insuranceGroupNameMissing = !event?.result?.insurance_group_name;
  
      const options = this.someInput?.formService?.popupForm?.controls?.sponser_id?.question_component?.question?.options;
      const currentSponsor = options?.find((c) => c.sponsor_name === event?.result?.sponsor_name);
  
      if (sponsorId && options?.length > 0) {
        const sponsorData = options.find((d) => d.id == sponsorId);

            if (!currentSponsor || (sponsorData && currentSponsor.id !== sponsorData.id)) {
              sponsorNameMissing = true;
              insuranceGroupNameMissing = true;
          }       
        if (sponsorData) {
          // Set sponsor_name if missing
          if (sponsorNameMissing && sponsorData.sponsor_name) {
            event.result.sponsor_name = sponsorData.sponsor_name;
          }
  
          // Set insurance-related fields if insurance_group_name is missing
          if (insuranceGroupNameMissing) {
            event.result.insurance_code = sponsorData.sponsorCode || '';
            event.result.insurance_name = sponsorData.sponsor_name || '';
            event.result.insurance_group_name = sponsorData.insurance_group_name || '';
            event.result.insurance_group_code = sponsorData.insurance_group_code || '';
            event.result.insurance_pan_no = sponsorData.pan_no || '';
            event.result.insurance_gstNo = sponsorData.gstNo || '';
            event.result.insurance_id = sponsorData.id || '';
          }
        }
      }
      // corporate_id / corporate_name are sent only when a corporate is selected
      if (event?.result) {
        const corporateId = event.result.corporate_id;
        if (corporateId) {
          const corporateOptions = this.someInput?.formService?.popupForm?.controls?.corporate_id?.question_component?.question?.options;
          const corporateData = corporateOptions?.find((c) => c.id == corporateId);
          if (corporateData?.name) {
            event.result.corporate_name = corporateData.name;
          }
        } else {
          delete event.result.corporate_id;
          delete event.result.corporate_name;
        }
      }
    } catch (error) {
      console.error('Error in sendToParent:', error);
    }
  if(event?.result?.payer_item_data)
  {
    event.result['payer_data'] = event.result.payer_item_data;
  }
    console.log("Event is", event);
    this.smartModalService.sendResult(event);
    this.dialogRef.close();
  }
  
  questionValueChanged(event){
    if (this.someInput && this.someInput.popupForm && event && event.question && event.question.question && event.question.question.key){
    if(this.dialogConfig && this.dialogConfig['co_pay_details'] && !(event?.question?.question?._manualChange))
      {        
      this.someInput.popupForm.controls.isCoPay.setValue(this.dialogConfig['co_pay_details'].isCoPay);
      this.someInput.popupForm.controls["co_pay_applicable_on"].question_component.question.visible = true;
      this.someInput.popupForm.controls.co_pay_applicable_on.setValue(this.dialogConfig['co_pay_details'].co_pay_applicable_on);
      this.someInput.popupForm.controls.patientPercentage.setValue(this.dialogConfig['co_pay_details'].patientPercentage)
      this.someInput.popupForm.controls["payer_data"].question_component.question.visible = true;
      this.someInput.popupForm.controls.payer_data.setValue(this.dialogConfig['co_pay_details'].payer_data)

      }
      if (this.someInput.popupForm.value.isCoPay && this.someInput.popupForm.value.co_pay_type && this.someInput.popupForm.value.co_pay_applicable_on) {
        if (event.question.question.key == "patientPercentage") {
          this.opAmount();
        }
        if (event.question.question.key == "patientAmount") {
          this.opAmount();
        }
      }
 else if (
  this.someInput.popupForm.value.co_pay_applicable_on &&
  ['serviceItem', 'serviceType'].includes(
    this.someInput.popupForm.value.co_pay_applicable_on)) 
    {
  this.opAmount();
}
      // if(event && event.question && event.question.question && event.question.question.key){
      //     if(event.question.question.key == "sponser_id"){
      //       debugger;
      //     }
      // }
    }
else if (
  ['ADD', 'edit', 'delete'].includes(event?.question?.val?.action) &&
  event?.question?.val?.items?.length > 0 &&
  event.question.val.items[0].co_pay_type) 
  {
  this.opAmount();
}
  }
  opAmount(){
    let latestOP_amount = sessionStorage.getItem("o____p__Pharmacy");
    if (latestOP_amount){
      let data = JSON.parse(latestOP_amount);
      data['random'] = Math.random();
      data.payer_details = this.someInput.popupForm.value;
      this.baseService.action(data, "GET_AMOUNT", "facility-management", "op_amount", false).subscribe((res) => {
        if (res.errCode == 0 && res.resource && res.resource.length > 0) {
          if (this.someInput && this.someInput.popupForm){
            this.someInput.popupForm.controls.authorized_amount.setValue(res.resource[0].payer_amount);
          }
          this.loader.hideSpinner();
        } else if (res.errCode == -1) {
          //TODO
        }
        this.loader.hideSpinner();
      },
        (err) => {
          this.loader.hideSpinner();
        }
      );
    }
   
  }
  
}

